import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
interface PressAnyKeyScreenProps {
  onContinue: () => void;
}
export function PressAnyKeyScreen({
  onContinue
}: PressAnyKeyScreenProps) {
  useEffect(() => {
    const handleKeyPress = () => {
      onContinue();
    };
    const handleClick = () => {
      onContinue();
    };
    window.addEventListener('keydown', handleKeyPress);
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      window.removeEventListener('click', handleClick);
    };
  }, [onContinue]);
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900 cursor-pointer" data-id="element-496">
      {/* Background */}
      <div className="absolute inset-0" data-id="element-497">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover opacity-30" data-id="element-498" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 to-slate-900/50" data-id="element-499" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full" data-id="element-500">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-501">
          <motion.p animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="text-2xl text-white/90 uppercase tracking-widest" data-id="element-502">
            Press any key to get started
          </motion.p>
        </motion.div>
      </div>
    </div>;
}